import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Account() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="blz-container py-10">
      <h1 className="font-display text-3xl font-bold">Account</h1>
      <div className="grid md:grid-cols-3 gap-6 mt-6">
        <div className="card-flat p-6">
          <div className="text-xs font-bold uppercase text-slate-500 mb-2">Profile</div>
          <div className="text-sm">
            <div><strong>{user.name}</strong></div>
            <div className="text-slate-500">{user.email}</div>
            {user.phone && <div className="text-slate-500">{user.phone}</div>}
          </div>
        </div>
        <Link to="/my-orders" className="card-flat p-6 hover:border-emerald-600">
          <div className="text-xs font-bold uppercase text-slate-500 mb-2">Orders</div>
          <div className="font-display text-2xl font-bold">View my orders →</div>
        </Link>
        <Link to="/wishlist" className="card-flat p-6 hover:border-emerald-600">
          <div className="text-xs font-bold uppercase text-slate-500 mb-2">Wishlist</div>
          <div className="font-display text-2xl font-bold">My saved items →</div>
        </Link>
      </div>
    </div>
  );
}
